export function kebabize(str) {
  return str
    .split('')
    .map((letter, idx) => {
      return letter.toUpperCase() === letter ? `${idx !== 0 ? '-' : ''}${letter.toLowerCase()}` : letter;
    })
    .join('');
}

export function addCodeToStory(story, code) {
  if (!story.parameters) {
    story.parameters = {};
  }
  if (!story.parameters.docs) {
    story.parameters.docs = {};
  }
  if (!story.parameters.docs.source) {
    story.parameters.docs.source = {};
  }
  story.parameters.docs.source.code = code;
}

export function genPropsCodeForStory(props) {
  if (props) {
    const list = [];
    Object.keys(props).forEach(prop => {
      let marker = '';
      let value = props[prop];
      if (typeof props[prop] !== 'string') {
        marker = ':';
        value = JSON.stringify(props[prop]);
      }
      list.push(`${marker}${kebabize(prop)}="${value}"`);
    });
    return list.join(' ');
  }
  return '';
}

export function addCodeToStoryWithTag(story, tag) {
  return addCodeToStory(story, `<${tag} ${genPropsCodeForStory(story.args)} />`);
}

export function convertSecondsToElapsedTime(seconds) {
  const format = val => `0${Math.floor(val)}`.slice(-2);
  const hours = seconds / 3600;
  const minutes = (seconds % 3600) / 60;
  return hours >= 1
    ? [hours, minutes, seconds % 60].map(format).join(':')
    : [minutes, seconds % 60].map(format).join(':');
}

export function convertElapsedTimeToSeconds(text) {
  return text
    .split(':')
    .reverse()
    .map((part, index) => {
      const multiplier = Math.pow(60, index);
      const time = Number(part) || 0;
      const seconds = multiplier * time;
      return seconds;
    })
    .reduce((total, current) => total + current);
}

// For Trial
export function chkTrialCompanyID(companyID) {
  if (companyID && companyID.match(/^tri[0-9]{6}$/)) {
    return true;
  }
  return false;
}
